<div class="tile" [ngClass]="platformType">
  <ion-card>
    <div class="banner-body">
      <img
        src="assets/images/autopay-banner-invoice-cursor.svg"
        alt="Invoice with cursor pointer"
      />

      <h5 [attr.data-cy]="'autopay-banner-text'">
        {{ 'i18n.payments.autopayBanner.text1' | translate }}
        <span class="second-line">
          {{ 'i18n.payments.autopayBanner.text2' | translate }}
        </span>
      </h5>
    </div>

    <ion-button
      [attr.data-cy]="'autopay-banner-text'"
      [ngClass]="'usf-outline-green-dsktp-tblt-modal-button'"
      (click)="onButtonClick()"
    >
      {{ 'i18n.payments.autopayBanner.buttonText' | translate }}
      <ion-icon
        *ngIf="!isAutopayEnabled"
        src="assets/icon/external-link-green.svg"
      ></ion-icon>
    </ion-button>
  </ion-card>
</div>
